






import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Vue } from 'vue-property-decorator'
import AuditForm from './auditInfoForm.vue'

@Component({
	name: 'partnerUpdateAuditInfo',
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
		PageLayout,
		AuditForm,
		// VisitorRange,
	},
})
export default class partnerUpdateAuditInfo extends Vue {}
